import { useEffect, useRef, useState } from "react";

export const useCountdown = (startedAt?: string, allowedSeconds?: number | null) => {
  const [left, setLeft] = useState<number | null>(null);
  const lastRef = useRef<number | null>(null);

  useEffect(() => {
    if (!allowedSeconds || !startedAt) {
      setLeft(null);
      return;
    }
    const started = new Date(startedAt).getTime();
    const end = started + allowedSeconds * 1000;
    const tick = () => {
      const now = Date.now();
      setLeft(Math.max(0, Math.floor((end - now) / 1000)));
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [startedAt, allowedSeconds]);

  return left;
};
